import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import {InputAdornment} from "@mui/material";
import React, {useEffect} from "react";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {useState} from "react";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import ManagerAddNew from "../managerInfo/ManagerAddNew";
import {RouteInfo} from "../../route/RouteHelper";
import {useNavigate} from "react-router-dom";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {Helmet} from "react-helmet";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";

let selectedItemID = -1

const ManagersList = () => {
    let page = 0;
    const size = 15

    const navigate = useNavigate()

    const service = new ManagerService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [isNeedRefresh, setIsNeedRefresh] = useState(false);


    useEffect(() => {
        if (service) {
            getManagerListFromServer()
        }
    }, [])


    const [openDialog, setOpenDialog] = useState(false)
    const [loadingManagerTable, setLoadingManagerTable] = useState(false)
    const [managerList, setManagerList] = useState([])
    const [pageCount, setPageCount] = useState(0);

    function handleAddNewManager() {
        selectedItemID = -1
        setOpenDialog(true)

    }

    function getManagerListFromServer() {
        setLoadingManagerTable(true)
        service.getManagerList(page, size)
            .then(response => {
                setLoadingManagerTable(false)
                setPageCount(response.totalPage)

                setManagerList([])
                response.data.map((item, index) => {
                    setManagerList(prevState => [
                        ...prevState,
                        prepareManagerListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.firstName,
                            item.lastName,
                            item.username,
                            item.phoneNumber,
                            item.createdBy,
                            item.createdAt,
                        )
                    ])
                })

            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            setLoadingManagerTable(false)
        })
    }

    function prepareManagerListRow(number, id, firstName, lastName, username, phoneNumber, createdBy, createdAt) {
        return {
            number,
            id,
            fullName: `${firstName} ${lastName}`,
            userName: username,
            accessLevel: "----",
            productionDate: createdAt ? convertUniversalDateToPersianDate(createdAt) : "نامشخص"
        }
    }

    function handlePagination(value) {
        page = value
        getManagerListFromServer()
    }

    function handleShowManagerInfo(rowId) {
        navigate(`${RouteInfo.ManagersDetail.globalUrl.replace(":id", rowId)}`)
    }

    function handleCloseManagerInfo() {
        setOpenDialog(false)
        if (isNeedRefresh) {
            page = 0
            getManagerListFromServer()
            setIsNeedRefresh(false)
        }
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseManagerInfo}
                open={openDialog}
                dialogSize={DialogSize.SMALL}
                pageTitle={"افزودن مدیر جدید"}
            >
                <ManagerAddNew changeNeedRefresh={setIsNeedRefresh}/>
            </RaikoDefaultDialogPage>
            <Helmet>
                <title>{RouteInfo.ManagersList.name}</title>
            </Helmet>
            <RaikoBaseContainer>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "مدیریت",
                            RouteInfo.ManagersList.url
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteInfo.ManagersList.name,
                            ""
                        ),
                    ]}/>

                <RaikoBaseCardContainer
                    className={`${css`
                      margin-top: 40px;
                    `}`}>
                    <RaikoGridOneColumn>

                        <ButtonDivisionSection>
                            {/*<RaikoMaterialOutlinedInput
                                labelText={"جست و جو"}
                                className="flex-grow-1"
                                spellCheck={false}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className={"search-icon"}/>
                                        </InputAdornment>
                                    ),
                                }}
                                placeHolder={"عبارت مورد نظر خود را وارد نمایید."}
                            />*/}
                            <ButtonPrimaryRaiko
                                label={"افزودن"}
                                className={css`height: max-content !important;`}
                                onClick={handleAddNewManager}
                            />
                        </ButtonDivisionSection>

                        <RaikoCustomTable
                            isLoading={loadingManagerTable}
                            data={managerList}
                            header={column}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            rowClicked={handleShowManagerInfo}/>

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>


        </>
    )
}
export default ManagersList;
const column = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
    },
    {
        id: 'userName',
        label: 'نام کاربری'
    },
    {
        id: 'accessLevel',
        label: 'سطح دسترسی',
    },
    {
        id: "productionDate",
        label: "تاریخ ساخت"
    }
]